import React from 'react';
import Spinner from './common/Spinner';

const LoadingSpinnerComponent = () => (
  <Spinner overlay={true} size="lg" text="Loading..." />
);

export default LoadingSpinnerComponent;
